module.exports = __webpack_public_path__ + "media/src/images/icons/chevron-forward-6a5c7786ce18c233e5a79f0d44b6d6c3.svg";